import { render, staticRenderFns } from "./TermosCondicoes.vue?vue&type=template&id=b9639dee&scoped=true"
import script from "./TermosCondicoes.vue?vue&type=script&lang=js"
export * from "./TermosCondicoes.vue?vue&type=script&lang=js"
import style0 from "./TermosCondicoes.vue?vue&type=style&index=0&id=b9639dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9639dee",
  null
  
)

export default component.exports